/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "[iF]ragment" }]*/

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import SiteVariablesFragment from "src/components/QueryFragments"
import { HomePageFragment } from "src/components/QueryFragments"

import "src/assets/scss/material-kit-react.scss"

import HomePageView from "../views/HomePage"

const HomePage = ({ location }) => {
  const {
    contentfulWebsiteGlobalVariables,
    contentfulPageHomepage
  } = useStaticQuery(
    graphql`
      query {
        contentfulWebsiteGlobalVariables {
          ...SiteVariablesFragment
        }
        contentfulPageHomepage {
          ...HomePageFragment
        }
      }
    `
  )

  return (
    <HomePageView
      siteVariables={contentfulWebsiteGlobalVariables}
      pageContent={contentfulPageHomepage}
      location={location}
    />
  )
}

export default HomePage
